export const defaultPageSize = 30;
export const maxPageSize = 100;
export const defaultPageNumber = 0;
export const defaultAutocompletePageSize = 7;
